import { useRef, useState } from "react";

export default function useOtpConfirmation<T>(
  submit: (payload: T & { otp_code: string }) => Promise<boolean>
) {
  const [pending, setPending] = useState<{
    payload: T;
    setSubmitting: (value: boolean) => void;
  } | null>(null);
  const inFlight = useRef(false);

  const requestOtp = (payload: T, setSubmitting: (value: boolean) => void) => {
    if (inFlight.current) return;
    setSubmitting(false);
    setPending({ payload: { ...payload }, setSubmitting });
  };

  const onClose = () => {
    if (inFlight.current) return;
    pending?.setSubmitting(false);
    setPending(null);
  };

  const onSubmit = async (otp_code: string) => {
    if (!pending || inFlight.current || !/^\d{6}$/.test(otp_code)) return;
    inFlight.current = true;
    pending.setSubmitting(true);
    setPending(null);
    try {
      await submit({ ...pending.payload, otp_code });
    } finally {
      inFlight.current = false;
      pending.setSubmitting(false);
    }
  };

  return {
    requestOtp,
    otpConfirmation: { isOpen: pending !== null, onClose, onSubmit },
  };
}
